<template>
  <div class="center-wallet">
    <div class="wallet-top">
      <div class="set-nav-title"><span class="line">我的钱包</span></div>
      <ul class="yue">
        <li class="item item1">
          <p>我的余额</p>
          <p class="balance">¥ <span class="balance-num">{{accountMoney}}</span></p>
        </li>
        <li class="item item2">
          <!--<button class="btn-base btn-recharge">充值</button>-->
          <!--<button class="btn-base btn-cash">提现</button>-->
        </li>
      </ul>
    </div>
    <div class="wallet-bot mt10">
      <p class="trans-detail">交易明细</p>
      <el-table
              class="trans-list"
              :data="transData"
              :default-sort = "{prop: 'rate', order: 'descending'}"
              :header-row-style="{'background-color':'#EBF3EE','border':'1px solid #E0E0E0'}"
              :header-cell-style="{
                  'background-color':'#EBF3EE',
                  'font-size':'14px',
                  'color':'#333333',
                  'height':'40px',
                  'padding':'0px',
                  'text-align':'left',
                  'padding-left':'20px',
                  'font-weight':'500'
              }"
              :cell-style="{
                  'padding-left':'20px'
              }"
      >
        <el-table-column
                prop="createTime"
                label="交易时间"
                width="300"
                align="left"
                class-name="cell-blue"
        >

        </el-table-column>
        <el-table-column
                prop="log"
                label="交易类型"
                width="300"
                class-name="cell-blue"
                align="left">
        </el-table-column>
        <el-table-column
                prop="money"
                label="收支金额（元）"
                align="left"
        >
          <template slot-scope="prop">
            <span :class="prop.row.money>0?'cell-red':''" v-text="prop.row.money>0?'+'+prop.row.money:prop.row.money"></span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
              @current-change="handleCurrentChange"
              :current-page="current"
              layout=" prev, pager, next,total, jumper"
              style="text-align: center;padding:20px;"
              :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import {getUserMoneyLog} from '../../api/user'
  export default {
      data(){
          return {
              accountMoney:0,//用户余额
              current:1,
              size:10,
              total:0,
              transData:[]
          }
      },
      components:{
      },
      mounted () {
          this.$store.dispatch("getMeInfoData").then(res=>{
              this.accountMoney=res.data.user.account;
          });
          this.getAccountLog();
      },
      methods:{
          handleCurrentChange(current){
              this.current=current;
              this.getAccountLog();
          },
          getAccountLog(){
              getUserMoneyLog({
                  current:this.current,
                  size:this.size
              }).then(res=>{
                  this.transData = res.data.records;
                  this.total = res.data.total;
                  console.log(res)
              })
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/common";
  .center-wallet{
    color:#333;
    font-size:20px;
    .wallet-top{
      padding:30px 40px 50px;
      background-color:#ffffff;
      .yue{
        display: table;
        padding:20px 25px 0px;
        .item{
          display: table-cell;
          &.item1{font-size:20px;
            font-weight:500;
            vertical-align: bottom;
            .balance{
              padding-top: 10px;
            }
            .balance-num{
              font-weight:700;font-size:40px;}
          }
          &.item2{vertical-align: bottom;padding:0 0 10px 90px;}
        }
      }
      .btn-base{width:90px;height:36px;font-size:20px;border:1px solid #BBBBBB;color:#333;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;}
      .btn-recharge{border:1px solid $main-color;color:#fff;margin-right:20px;background-color:$main-color;}
      .btn-cash{background-color:#F5F5F5;}
    }
    .wallet-bot{
      background: #ffffff;
      padding:28px 40px;
      .trans-detail{padding-left:24px;padding-bottom:20px;}
    }
  }
  .cell-blue{
    color:#1457D1;
  }
  .cell-red{
    color:#FF4A4A;
  }
  .trans-list{font-size:16px;}
</style>
